import metrics from "./init-metrics";

let baseParams: Record<string, string> = {};
let stageParams: Record<string, string> = {};

const sanitize = (patch: Record<string, string | undefined | null>) => {
  const result: Record<string, string> = {};
  Object.entries(patch).forEach(([k, v]) => {
    if (typeof v === "string" && v.trim().length > 0) {
      result[k] = v;
    }
  });
  return result;
};

const applyParams = () => {
  metrics.setCustomParams({ ...baseParams, ...stageParams });
};

export const resetMetricsParams = () => {
  baseParams = {};
  stageParams = {};
  metrics.setCustomParams({});
};

export const replaceBaseParams = (patch: Record<string, string | undefined | null>) => {
  baseParams = sanitize(patch);
  applyParams();
};

export const mergeBaseParams = (patch: Record<string, string | undefined | null>) => {
  baseParams = { ...baseParams, ...sanitize(patch) };
  applyParams();
};

export const setStageParams = (patch: Record<string, string | undefined | null>) => {
  stageParams = { ...stageParams, ...sanitize(patch) };
  applyParams();
};

export const resetStageParams = () => {
  stageParams = {};
  applyParams();
};

export const getStageParams = () => ({ ...stageParams });
